export const validationMessages = {
  required: "Skal være sat",
  validEmail: "Skal være en gyldig email adresse",
  dateEndBeforeStart: "Slutdato kan ikke være før startdato",
  invalidDate: "Skal være en gyldig dato",
};
